import { CardItem } from '../components/CardItem';

export const informations: CardItem[] = [
  {
    title:
      'Localização dos locais propensos a deslizamentos no Rio Grande do Sul',
    description: null,
    image: ['/images/mapa/mapa-deslizamentos.jpg'],
    alt: 'Localização dos locais propensos a deslizamentos no Rio Grande do Sul',
    link: 'https://fernandohillebrand.users.earthengine.app/view/suscetibilidade-movimentos-de-massa-rs',
    source: 'Grupo de Pesquisas em Desastres Naturais (GPDEN) da UFRGS.',
  },
  {
    title: 'Acesso a séries históricas da Rede Hidrometeorológica Nacional',
    description: null,
    image: ['/images/mapa/rede_hidrometeorologica_nacional.png'],
    alt: 'Acesso a séries históricas da Rede Hidrometeorológica Nacional',
    link: 'https://www.snirh.gov.br/hidroweb/mapa',
    source: 'Agência Nacional de Águas (ANA).',
  },
  {
    title:
      'Manchas das inundações e movimentos de massa no Rio Grande do Sul no evento extremo de maio de 2024',
    description: null,
    link: 'https://www.arcgis.com/apps/webappviewer/index.html?id=0149f5a72e4e4ec48fa52469a78b270b&extent=-5781429.6672%2C-3414365.0236%2C-5777703.3621%2C-3412203.2889%2C102100',
    image: ['/images/mapa/mancha_inundacao_2024.jpg'],
    source: 'Instituto de Geociências (IGeo) da UFRGS.',
    alt: 'Manchas das inundações e movimentos de massa no Rio Grande do Sul no evento extremo de maio de 2024',
  },
  // {
  //   description: null,
  //   link: 'https://drive.google.com/file/d/1XteeMG6RXhcJU1-c1ONt-7mn9rxkWmzq/view',
  //   image: ['/images/mapa/mapeamentos_mancha_inundacao.jpg'],
  //   title:
  //     'Mapeamento da mancha de inundação do dia 02 de maio de 2024 na área urbana',
  //   source: null,
  //   alt: 'Mapeamento da mancha de inundação do dia 02 de maio de 2024 na área urbana',
  // },
  // {
  //   description: null,
  //   link: 'https://drive.google.com/file/d/1BHC6nf4plIyDi1hpV6qIJtSpOY4pMH86/view',
  //   image: ['/images/mapa/mapeamento_profundidade_inundacao.jpg'],
  //   title:
  //     'Mapeamento da profundidade da inundação do dia 02 de maio de 2024 na área urbana',
  //   source: null,
  //   alt: 'Mapeamento da profundidade da inundação do dia 02 de maio de 2024 na área urbana',
  // },
  {
    title:
      'Acesso ao mapa interativo da Rede Observacional para Monitoramento de Risco de Desastres Naturais',
    description: null,
    link: 'https://mapainterativo.cemaden.gov.br/#',
    image: ['/images/mapa/mapa_interatico_cemaden.png'],
    alt: 'Acesso ao mapa interativo da Rede Observacional para Monitoramento de Risco de Desastres Naturais',
    source: 'Centro de Monitoramento em Desastres Naturais (Cemaden).',
  },
  {
    title:
      'Mapeamento da mancha e profundidade de inundação na zona urbana de Rolante/RS',
    description: null,
    link: 'https://www.google.com/maps/d/u/1/edit?mid=1OFex3vMQyHqhzMpSfiMRpFqmkmEqn9k&usp=sharing',
    image: ['/images/mapa/mapa-mancha-e-profundidade.jpg'],
    alt: 'Mapeamento da mancha e profundidade de inundação na zona urbana de Rolante/RS',
    source: null,
  },
  {
    title: "Levantamento topobatimétrico dos cursos d'água",
    description: null,
    link: 'https://www.google.com/maps/d/u/1/edit?mid=1FCN6GHxhSzvXJNz7xtbqJkhz_cD18s8&usp=sharing',
    image: ['/images/mapa/topobatimetrico.jpg'],
    alt: "Levantamento topobatimétrico dos cursos d'água",
    source: null,
  },
  {
    title:
      'Cheias no Rio Grande do Sul - Base de dados e informações geográficas na Região Hidrográfica do Lago Guaíba e na Lagoa dos Patos em 2024',
    description: null,
    link: 'https://storymaps.arcgis.com/stories/a81d69f4bccf42989609e3fe64d8ef48',
    image: ['/images/mapa/cheias-rs.png'],
    alt: 'Cheias no Rio Grande do Sul em 2024',
    source: 'Universidade Federal do Rio Grande do Sul (UFRGS).',
  },
];
